// extracted by mini-css-extract-plugin
module.exports = {"item":"LanguagePicker_item__3AdtU","link":"LanguagePicker_link__gtmTh","icon":"LanguagePicker_icon__SSQbd"};